/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MagnifyingGlassPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB2ElEQVR4nMWUzS4EQRDHx5nlhLg6cPRxJCEkZBPb1dWSnipr32SXN+EBiGcglhsXNvH1BFaCIBxJdc/YtTFjRmxU0smkp7t+//roCoL/shLSstK0pZAvQdOb0vwMyDduz/Dirx0j0hhoqgPye+rSVF9ZLY/mcg4QzgHSvThQmm4Bqap1eXJpqdIrC4CnALnm/8kZflSr4Wx25ZFz0LwDAIVkIVBQSLsOgvQAYMd/Vh+nRfNOEAQ9GTT1tCC8n3pHCvqZlm+UK+RjEdC5Xyyu94PmphMG4UIiQDrDF4+q30aHvrAJdzcicVspAL6SQysmnMgLAF94EddIA7z6MFvpcWnB5BZtAaAQAV7SAM+dgLS3oJAPv9TB7z0lAkDTtRySnu9SiigqMtdyA5A2owi2kwGGF9PaFDTV29MSm7V2AJDu5G4J1+YTAbGT6GXuZn1ooHkvKvrBj3dkcMlsiSFSvKSzTnns3NWOZjIICgIZXG62+JHRlEdUMuG0tbZPlnz7nPu0tNqWz42pDGWCyOCS2ZJhXB+IcnGeG+LyC+GC7y5q+CnrVkO6pb2g4vQTgtTIA8lsRWsHFdJZFNmFMesjfw4xEomL1jXJSdANU4qHQfMpaD7qCuBf7AN/QU6Gwz8EFAAAAABJRU5ErkJggg==)
 */
export const MagnifyingGlassPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M15.62 17.03a9 9 0 1 1 1.41-1.41l4.68 4.67a1 1 0 0 1-1.42 1.42l-4.67-4.68ZM17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M11 7a1 1 0 1 0-2 0v2H7a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2V7Z"
        className={colorClass}
      />
    </svg>
  );
};
